import { Dtos, type SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { proConsQueryKey } from "../decisioning.keys";

const parseProCons = (data: unknown) =>
	Dtos.Decisioning.ProCon.Get.Response.schema.array().parse(data);

export const useFetchAdminProCons = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const query = useQuery({
		queryKey: proConsQueryKey(accountId),
		meta: { suppressErrorModal: true },
		queryFn: async () =>
			parseProCons(await get<unknown>(`/v2/admin/surety/accounts/${accountId}/pro-cons`)),
	});

	return {
		proCons: query.data,
		proConsIsLoading: query.isLoading,
		proConsError: query.error,
		refetchProCons: query.refetch,
	};
};
